import {
  DomainGroup,
  domainGroupEnum,
  getOtherDomainGroup,
} from "@shared/utils/domain-group";
import { useDomainGroup } from "./useDomainGroup";

export const APP_NAME: Record<DomainGroup, string> = {
  [domainGroupEnum.SIDEKICK]: "Sidekick",
  [domainGroupEnum.RADAR]: "Radar",
};

export const useAppName = (): string => APP_NAME[useDomainGroup()];

export const useOtherAppName = (): string =>
  APP_NAME[getOtherDomainGroup(useDomainGroup())];
